import { formatTime, rupiah } from '@/lib/format';
import { isBookableSlot } from '@/lib/slotAvailability';
import type { Slot } from '@/types/product.slot';

/** Radix Select forbids an empty-string item value → sentinel for "no choice". */
export const SLOT_NONE = '__none__';

/**
 * Pickable slots: OPEN / EVENT_OVERRIDE, room left (or unlimited), and not
 * already ended on the visit date. One rule shared with the catalog cards
 * (`isBookableSlot`), so the cashier can't pick a slot whose time has passed
 * (#1620 — it used to check capacity and status only).
 */
export function selectableSlots(slots: Slot[], visitDate?: string): Slot[] {
  return slots.filter((s) => isBookableSlot(s, { visitDate }));
}

/** Prefer the ISO `slotStartAt`/`slotEndAt` (localStart may be a bare label). */
export function slotTimeLabel(slot: Slot): string {
  const start = slot.slotStartAt ?? slot.localStart;
  const end = slot.slotEndAt ?? slot.localEnd;
  return `${formatTime(start)}${end ? `–${formatTime(end)}` : ''}`;
}

/**
 * `" · Rp 155.000"` for an add-on slot option, from the availability `price`
 * — a time-of-day rate prices slots of one attraction differently, so the
 * cashier sees the price before picking. Empty when the slot carries none.
 */
export function slotPriceSuffix(slot: Slot): string {
  return typeof slot.price === 'number' ? ` · ${rupiah(slot.price)}` : '';
}
